import firebase from '@/plugins/firebase'

var db = firebase.firestore();
export default db
